<template>
  <div v-if="active" class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-50"></div>
  <div v-if="active" class="fixed inset-0 flex justify-center items-center z-50 blur-none my-16" @click="closePopup">
    <div
      class="bg-[#fff] w-[570px] my-52 rounded-3xl overflow-hidden h-fit flex flex-col border-2 border-b-gray-300 absolute"
      @click="handleClickPropagation">
      <span class="absolute right-6 top-2 scale-[240%]" @click="closePopup">&times;</span>
      <div class="flex flex-col flex-grow items-center h-full mx-10 my-9 gap-6">
        <iconMailSend :size="90" :color="getSelectedTypeStyleIcon" class="w-56" alt="" />
        <div class="flex flex-col gap-4">
          <span>{{ $t('Pos.SendRequestStock') + productName }}</span>
          <textarea name="note" id="textarea" :placeholder="$t('Pos.Note')" style="border: 2px solid #ccc;
  border-radius: 5px; padding: 0 5px;" cols="50" rows="2"></textarea>
        </div>
        <button @click="sendRequest"
            class="bg-primary flex w-full rounded-md py-2 text-lg items-center justify-center gap-3 text-white">{{
              $t('Pos.SendRequest') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import iconMailSend from "./icons/iconMailSend.vue"
import router from "@/router";
export default {
  name: "LbrxRequestPopup",
  components: {
    iconMailSend
  },
  data() {
    return {
      activeKey: '0',
      checkedItems: [],
      quantity: ""
    };
  },
  props: {
    active: {
      required: true,
      value: Boolean
    },
    productName: {
      required: false,
      value: String
    },
    type: {
      required: false,
      value: String
    }
  },
  computed: {
    getSelectedTypeStyleIcon() {
      return JSON.parse(localStorage.getItem('themeTemplate')).primaryColor;
    }
  },
  methods: {
    closePopup() {
      this.$emit("closePopup")
    },
    handleClickPropagation() {
      event.stopPropagation();
    },
    goDrawer() {
      router.push('/cashier');
    },
    markOffer() {
      router.push('/checkout');
    },
    proceedNormal() {
      router.push('/checkout');
    }
  }
};
</script>

<style scoped>
input[type=checkbox] {
  transform: scale(1.5);
}
</style>